var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72716 1.00781H7.04506C7.50313 1.00781 7.94244 1.18978 8.26634 1.51369C8.59025 1.83759 8.77222 2.2769 8.77222 2.73497V8.78003H2.72716C2.26909 8.78003 1.82978 8.59806 1.50587 8.27416C1.18197 7.95025 1 7.51094 1 7.05287V2.73497C1 2.2769 1.18197 1.83759 1.50587 1.51369C1.82978 1.18978 2.26909 1.00781 2.72716 1.00781Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9537 1.00781H18.2716C18.7297 1.00781 19.169 1.18978 19.4929 1.51369C19.8168 1.83759 19.9988 2.2769 19.9988 2.73497V7.05287C19.9988 7.51094 19.8168 7.95025 19.4929 8.27416C19.169 8.59806 18.7297 8.78003 18.2716 8.78003H12.2266V2.73497C12.2266 2.2769 12.4085 1.83759 12.7324 1.51369C13.0563 1.18978 13.4957 1.00781 13.9537 1.00781Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72716 12.2715H8.77222V20.0437H2.72716C2.26909 20.0437 1.82978 19.8617 1.50587 19.5378C1.18197 19.2139 1 18.7746 1 18.3165V13.9986C1 13.5406 1.18197 13.1013 1.50587 12.7774C1.82978 12.4535 2.26909 12.2715 2.72716 12.2715Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 12.2715H18.2716C18.7297 12.2715 19.169 12.4535 19.4929 12.7774C19.8168 13.1013 19.9988 13.5406 19.9988 13.9986V18.3165C19.9988 18.7746 19.8168 19.2139 19.4929 19.5378C19.169 19.8617 18.7297 20.0437 18.2716 20.0437H12.2266V12.2715Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.bb2e598c422a79c95112794175290f01.svg";
export { ForwardRef as ReactComponent };